// https://github.com/axios/axios/issues/164#issuecomment-327837467
/**
 *
 * @export setupAxiosRetry
 * @param {axios} axios
 * @param {object} config - contain retry and __retryCount for counting retry
 * @param {boolean} [customValidation=() => true] - return true if valid for retry, or false if you don't want to retry.
 * @returns
 */
export default function setupAxiosRetry(axios, config, customValidation = () => true) {
  axios.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
    const config = err.config;

    // If config does not exist or the retry option is not set, reject
    if (!config || !config.retry) return Promise.reject(err);

    if (!customValidation(err)) return Promise.reject(err);

    // Set the variable for keeping track of the retry count
    config.__retryCount = config.__retryCount || 0;

    // Check if we've maxed out the total number of retries
    if (config.__retryCount >= config.retry) {
      // Reject with the error
      return Promise.reject(err);
    }

    // Increase the retry count
    config.__retryCount += 1;

    // Create new promise to handle exponential backoff
    const backoff = new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, config.retryDelay || 1);
    });

    // Return the promise in which recalls axios to retry the request
    return backoff.then(() => {
      return axios(config);
    });
  });
  return axios;
}
